import React from 'react';
import PropTypes from 'prop-types';

import EmptyListIcon from '@chronos/components/Icons/EmptyListIcon';
import TransactionsList from '../TransactionsList';

import * as S from './styled';

const currencyEmojiMap = {
  USD: '💵',
  EUR: '💶',
};

const DashboardTransactions = ({
  transactions,
  workspaces,
  listItems,
  dayPoints,
  transactionsCount,
  loadMoreTransactions,
  isItemLoaded,
  infiniteLoaderRef,
  listRef,
  autosizerRef,
  totalIncome,
}) => {
  const TotalIncome = (
    <S.TotalIncome>
      <S.Income>
        {Object.keys(totalIncome).map((currency) => (
          <div
            key={currency}
            style={{ marginRight: '8px' }}
          >
            {currencyEmojiMap[currency]} {currency}: {totalIncome[currency]}
          </div>
        ))}
      </S.Income>
    </S.TotalIncome>
  );

  if (!transactionsCount) {
    return (
      <>
        {TotalIncome}
        <S.Divider />
        <S.ItemsPlaceholder>
          <S.NoItems>
            <div>
              <EmptyListIcon size="huge" />
            </div>
            <em>No transactions found...</em>
          </S.NoItems>
        </S.ItemsPlaceholder>
      </>
    );
  }

  return (
    <>
      {TotalIncome}
      <S.Divider />
      <S.TransactionsList>
        <TransactionsList
          transactions={transactions}
          workspaces={workspaces}
          listItems={listItems}
          dayPoints={dayPoints}
          transactionsCount={transactionsCount}
          loadMoreTransactions={loadMoreTransactions}
          isItemLoaded={isItemLoaded}
          infiniteLoaderRef={infiniteLoaderRef}
          listRef={listRef}
          autosizerRef={autosizerRef}
        />
      </S.TransactionsList>
    </>
  );
};

DashboardTransactions.propTypes = {
  ...TransactionsList.propTypes,
  totalIncome: PropTypes.object,
};

DashboardTransactions.defaultProps = {};

export default DashboardTransactions;
